import * as stylex from '@stylexjs/stylex';
import { colors } from '../../shared/tokens/colors.stylex';
import { typography } from '../../shared/tokens/typography.stylex';
import { fonts } from '../../shared/tokens/fonts.stylex';
import { palette } from '@shared/tokens/palette.stylex';

export const styles = stylex.create({
  base: {},

  openEmail: {
    cursor: 'pointer',
    fontSize: '10px',
    color: palette['bronze-400'],
    ':hover': {
      textDecoration: 'underline',
      textUnderlineOffset: '1px',
    },
  },
  openSms: {
    cursor: 'pointer',
    fontSize: '10px',
    color: palette['bronze-400'],
    whiteSpace: 'nowrap',
    ':hover': {
      textDecoration: 'underline',
      textUnderlineOffset: '1px',
    },
  },

  infoWidget: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    flex: '1 0 0',
    alignSelf: 'stretch',
  },

  progressBarContainer: {
    width: '100%',
    height: '24px',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-2'],
    fontStyle: 'normal',
    fontFamily: fonts.din2014Regular,
    padding: '6px 24px',
  },
  total: {
    width: '100%',
    backgroundColor: palette['grey-50'],
  },
  recognized: (width: string) => ({
    width,
    backgroundColor: palette['grey-300'],
  }),
  unrecognized: (width: string) => ({
    width,
    backgroundColor: palette['grey-950'],
    color: palette['greyWhite'],
  }),

  userItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 16px',
    borderBottom: `1px solid red`,
  },

  userTable: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: '1 0 0',
    minWidth: '548px',
    height: '256px',
    color: colors.primaryText,
    backgroundColor: colors.primaryBackground,
    fontFamily: fonts.din2014Regular,
    fontSize: '14px',
  },
  userTableText: {
    color: palette['grey-500'],
  },
  userHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    fontSize: '14px',
    borderBottom: '1px solid var(--border-tertiary, rgba(29, 37, 45, 0.10))',
    paddingTop: '20px',
  },
  headerName: {
    display: 'flex',
    width: '165px',
    height: '36px',
    minWidth: '165px',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    rowGap: '10px',
    flexWrap: 'wrap',
  },
  headerEmail: {
    display: 'flex',
    width: '165px',
    height: '36px',
    minWidth: '165px',
    alignItems: 'flex-start',
    gap: '10px',
    flexWrap: 'wrap',
  },
  headerPhone: {
    display: 'flex',
    width: '165px',
    height: '36px',
    minWidth: '165px',
    alignItems: 'flex-start',
    rowGap: '10px',
    flexWrap: 'wrap',
  },
  itemName: {
    display: 'flex',
    width: '165px',
    height: '36px',
    minWidth: '165px',
    padding: '8px  16px',
    alignItems: 'center',
    gap: ' 8px',
    flex: '1 0 0',
    alignSelf: 'stretch',
  },
  itemEmail: {
    display: 'flex',
    minWidth: ' 36px',
    padding: '8px 16px',
    alignItems: 'center',
    gap: ' 8px',
    alignSelf: 'stretch',
  },
  itemPhone: {
    display: 'flex',
    minWidth: ' 36px',
    padding: '8px 16px',
    alignItems: 'center',
    gap: ' 8px',
    alignSelf: 'stretch',
  },

  content: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch',
    fontFamily: fonts.din2014Regular,
  },

  main: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: '1 0 0',
    padding: '0px 32px',
  },

  infoSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    flex: '1 0 0',
    fontFamily: 'DIN 2014',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '12px',
  },
  prorgessSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    flex: '1 0 0',
    alignSelf: 'stretch',
  },
  accepted: {
    display: 'flex',
    padding: ' 6px 0px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '3px',
    color: palette['grey-500'],
  },
  notAccepted: {
    display: 'flex',
    padding: '6px 0px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    color: palette['grey-500'],
  },
  unrecongnized: {
    display: 'flex',
    padding: '6px 0px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    color: palette['grey-500'],
    whiteSpace: 'pre-wrap',
  },
  statusRow: {
    display: 'flex',
    gap: '3px',
    alignItems: 'center',
  },
  percentValue: {
    color: palette['bronze-500'],
    marginLeft: '2px',
  },
  progressValue: {
    color: colors.ghostText,
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    alignItems: 'center',
    height: '66px',
    padding: '16px 24px ',
  },
  scrollContainer: {
    overflowY: 'auto',
    width: '100%',
  },
  mainError: {
    width: '100%',
  },
  contactType: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    height: '256px',
    padding: '0px 24px',
  },
  contactHeader: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '200px 160px 232px',
    alignItems: 'center',
    alignSelf: 'stretch',
    fontSize: '14px',
    borderBottom: '1px solid var(--border-tertiary, rgba(29, 37, 45, 0.10))',
    height: '36px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: colors.primaryBackground,
  },
  contactUser: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '200px 160px 232px',
    borderBottom: '1px solid var(--border-tertiary, rgba(29, 37, 45, 0.10))',
  },
  fullName: {
    display: 'flex',
    width: ' 200px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
  },
  fullNameItem: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  phoneUser: {
    display: 'flex',
    width: '160px',
    height: '44px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  phoneUserItem: {
    display: 'flex',
    padding: '8px 16px',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  errorInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '10px',
    flex: '1 0 0',
  },
  errorInfoItem: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    wordBreak: 'break-word', // Переносить слово, если оно не помещается
    overflowWrap: 'break-word', // Альтернативный стандарт для переноса
    whiteSpace: 'normal',
  },
  contactInfo: {
    display: 'flex',
    width: '144px',
    height: '36px',
    minWidth: '144px',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    rowGap: '10px',
    flexWrap: 'wrap',
  },
  contactItem: {
    display: 'flex',
    minWidth: '36px',
    padding: '8px var(--space-16, 16px)',
    alignItems: 'center',
    gap: ' 8px',
    flex: '1 0 0',
    alignSelf: 'stretch',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 0 56px 0',
  },
});
